import React from "react";
import { Text, View, StyleSheet, Link, Image } from "@react-pdf/renderer";
import { getShortFormString } from "../../../pages/site-overview/helper";
import LinkSvg from "../../../Assets/rank-tracking-assets/link.png";

// Define styles
const styles = StyleSheet.create({
  table: {
    width: "100%",
    display: "table",
    marginBottom: 10,
    marginTop: 10,
    overflow: "hidden",
  },
  row: {
    flexDirection: "row",
    paddingVertical: 4,
    borderBottomWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderColor: "#ddd",
    minHeight: 25,
  },
  table_header: {
    backgroundColor: "#EAE9E9",
    fontWeight: "bold",
    paddingVertical: 6,
    textTransform: "capitalize",
  },
  cell: {
    flex: 1,
    textAlign: "center",
    padding: 5,
    fontSize: 8,
  },
  leftAlign: { textAlign: "left" },
  centerAlign: { textAlign: "center" },
});

const TablePagePdf = ({ data }) => {
  const { rows, columns, title, columnMapping } = data;
  return (
    <>
      {columnMapping?.length > 1 && (
        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontSize: 12, marginBottom: 5, fontWeight: 700 }}>
            *Note
          </Text>
          {columnMapping?.map((obj, index) => {
            if (index === 0) return null;
            const key = Object.keys(obj)[0]; // Extract key dynamically
            const value = obj[key]; // Extract value dynamically
            return (
              <View
                key={index} // Use index as key since object keys are dynamic
                style={{
                  fontSize: 11,
                  flexDirection: "row",
                  marginBottom: 5,
                  fontWeight: "700",
                }}
              >
                <Text
                  style={[{ color: "#00000099", textTransform: "capitalize" }]}
                >
                  {key}:{" "}
                </Text>
                <Text style={[{ color: "#000000" }]}>{value}</Text>
              </View>
            );
          })}
        </View>
      )}
      <Text style={{ fontSize: 13, marginBottom: 5, fontWeight: 700 }}>
        {title}
      </Text>
      <View style={styles.table}>
        <View style={[styles.row, styles.table_header]} fixed>
          {columns?.map((col) => (
            <Text
              key={col}
              style={[
                styles.cell,
                col === "keyword" || col === "Keywords"
                  ? styles.leftAlign
                  : styles.centerAlign,
                { fontSize: 10, color: "#313034" },
              ]}
            >
              {col}
            </Text>
          ))}
        </View>
        {rows?.map((row, rowIndex) => (
          <View key={rowIndex} style={styles.row} wrap={false}>
            {columns?.map((col, index) => {
              if (col === "keyword" || col === "Keywords") {
                return (
                  <View
                    key={`${col}` + index}
                    style={[styles.cell, styles.leftAlign]}
                  >
                    <Text style={{ fontSize: 9, color: "#020202" }}>
                      {row[col]}
                    </Text>
                    <View style={{ flexDirection: "row" }}>
                      <Text style={{ fontSize: 8, color: "#020202" }}>
                        {`(${getShortFormString(row.location)})`}
                      </Text>
                      {row?.URL && (
                        <Link src={row.URL} style={{ marginLeft: 2 }}>
                          <Image
                            src={LinkSvg}
                            style={{
                              width: 15,
                              height: 12,
                              objectFit: "contain",
                            }}
                          />
                        </Link>
                      )}
                    </View>
                  </View>
                );
              } else {
                return (
                  <Text
                    key={`${col}` + index}
                    style={[
                      styles.cell,
                      styles.centerAlign,
                      row?.[col] === "Pending"
                        ? { fontSize: 9, color: "green" }
                        : { fontSize: 9, color: "#5F5E62" },
                    ]}
                  >
                    {row[col] && typeof row[col] === "object"
                      ? row[col].rank_group ?? "-" // If it's an object, get ranks_group; otherwise, show "-"
                      : row[col] ?? "-"}{" "}
                    {/* Handle non-object values */}
                  </Text>
                );
              }
            })}
          </View>
        ))}
      </View>
    </>
  );
};

export default TablePagePdf;
